module.exports = "../../app/cells/pages/questions/question_likes_cell.rb";